<ng-container *flexyooLet="agreementFilePath$ | async as agreementFilePath">
  @if (agreementFilePath) {
    <div class="benefit-sign-digital__preview-actions">
      <button
        aria-label="Remove button"
        class="benefit-sign-digital__back-button"
        matButton="filled"
        (click)="onRemoveAgreementFile()"
      >
        <mat-icon>keyboard_backspace</mat-icon>
        {{ 'base-layout.back' | translate | uppercase }}
      </button>
      <app-employee-benefit-sign-footer (cancelSelection)="cancelSign()" (send)="send.emit(file)">
      </app-employee-benefit-sign-footer>
    </div>
    <div class="benefit-sign-digital__preview">
      <pdf-viewer
        [original-size]="false"
        [render-text]="true"
        [show-all]="true"
        [show-borders]="true"
        [src]="agreementFilePath"
      >
      </pdf-viewer>
    </div>
  } @else if (showManualSteps()) {
    <div class="benefit-sign-digital__manual">
      <p class="benefit-sign-digital__hint">
        {{
          'employee.benefit-' +
            documentType +
            '-sign.manual-option-desc' +
            (isQuillSignPossible ? '' : '-unique') | translate
        }}
      </p>
      <div class="benefit-sign-digital__steps">
        <div class="benefit-sign-digital__step">
          <span aria-hidden="true" class="benefit-sign-digital__step-number">1</span>
          <span class="benefit-sign-digital__step-text">
            {{ 'employee.benefit-' + documentType + '-sign.steps.download' | translate }}
          </span>
          <button
            aria-label="Download button"
            class="benefit-sign-digital__step-action"
            type="button"
            (click)="downloadBenefitAddendumTemplate.emit()"
          >
            <mat-icon>download</mat-icon>
          </button>
        </div>
        <div class="benefit-sign-digital__step">
          <span aria-hidden="true" class="benefit-sign-digital__step-number">2</span>
          <span class="benefit-sign-digital__step-text">
            {{ 'employee.benefit-' + documentType + '-sign.steps.sign' | translate }}
          </span>
        </div>
        <div class="benefit-sign-digital__step">
          <span aria-hidden="true" class="benefit-sign-digital__step-number">3</span>
          <span class="benefit-sign-digital__step-text">
            {{ 'employee.benefit-' + documentType + '-sign.steps.upload' | translate }}
          </span>
          <flexyoo-file-upload
            class="benefit-sign-digital__step-action"
            iconView
            [acceptedFormats]="acceptedFileFormat"
            (fileUploaded)="onUserAgreementFileChange($event?.file)"
          ></flexyoo-file-upload>
        </div>
      </div>
    </div>
    <a
      class="benefit-sign-digital__howto"
      mat-button
      target="_blank"
      [href]="staticUserAgreementHowTo"
      >{{ 'employee.user-agreement-sign.how-to' | translate | uppercase }}</a
    >
  }
</ng-container>
